module.exports = __webpack_public_path__ + "static/media/learning-25.bd6dcfb2.png";